// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCardStickers_container__2MgRk","pinkColor":"ProductCardStickers_pinkColor__2taoY"};